import moment from 'moment';
import styled from 'styled-components';
import { Tooltip, withStyles } from '@material-ui/core';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Icon from 'components/base/Icon';
import { DATE_FORMAT, HOUR_FORMAT, MOMENT } from 'common/constants/constants';
import { LBButton, LBXIcon } from '@linearb/buzz';

const TooltipWrapper = withStyles({
  popper: {
    zIndex: 1500
  }
})(Tooltip);

const MarkAsReadWrapper = styled(Flex)`
  margin-left: auto;
  min-width: 1.5rem;
`;

const formatDate = date => {
  let dayFormat = 'dddd';
  const diff = moment(date).diff(moment(), MOMENT.UNITS.DAY as any);

  if (Math.abs(diff) > 2) {
    //more than two days
    return moment(date).format(DATE_FORMAT);
  }

  if (diff === MOMENT.DIFF.TODAY) {
    dayFormat = '[Today]';
  }

  if (diff === MOMENT.DIFF.YESTERDAY) {
    dayFormat = '[Yesterday]';
  }
  return moment(date).format(`${dayFormat}, ${HOUR_FORMAT}`);
};

export const BaseMessage = ({
  icon: Logo,
  title,
  description,
  callToAction,
  date,
  isRead = false,
  id,
  markAsRead = () => null,
  deleteMessage = () => null
}) => {
  return (
    <div className='p-4 last:mb-4'>
      <Flex items='flex-start'>
        {Logo && (
          <div>
            <Logo className='size-8' />
          </div>
        )}
        <Flex direction='column' pl='normal'>
          <Text color='osloGray'>{formatDate(date)}</Text>
          <Text weight='500' size='large' mt='0.5rem'>
            {title}
          </Text>
          <div className='text-xs'>{description}</div>
          {callToAction ? (
            <div className='flex flex-row gap-4 w-full -mx-1 mt-4 mb-8'>
              {callToAction}
            </div>
          ) : null}
        </Flex>
        <Flex items='center' ml='auto'>
          <MarkAsReadWrapper>
            {!isRead && (
              <TooltipWrapper
                title='Mark as read'
                placement='bottom-end'
                interactive={true}
              >
                <LBButton
                  size='icon'
                  variant='ghost'
                  id='markAsRead'
                  // @ts-ignore
                  onClick={() => markAsRead([id])}
                >
                  <Icon
                    name='fibermanualrecordicon'
                    color='dodgerBlue'
                    size='smaller'
                  />
                </LBButton>
              </TooltipWrapper>
            )}
          </MarkAsReadWrapper>
          <TooltipWrapper
            title='Delete message'
            placement='bottom-end'
            interactive
          >
            <LBButton
              size='icon'
              variant='ghost'
              // @ts-ignore
              onClick={() => deleteMessage([id])}
            >
              <LBXIcon />
            </LBButton>
          </TooltipWrapper>
        </Flex>
      </Flex>
    </div>
  );
};
